import { IRouteObj } from "interface/common";
import React from "react";

//base
export const linkBasePath = "/dashboard";

//No Auth Routes
export const linkPageBase = "/";
export const linkPageLogin = "/login";
export const linkPageSignUp = "/signup";
export const linkPageJoin = "/join";
export const linkPageForgotPassword = "/forgot-password";
export const linkPageResetPassword = "/reset-password";

//With auth routes but not inside default layout
export const linkAuthBase = "/auth";
export const linkPageDatadogAuthManagement = "/datadog";

//links
export const linkAuthRoute = "/console";

//Boilerplate Items: To be deleted
export const linkPageView1 = "/view1";
export const linkPageView2 = "/view2";
export const linkPageView3 = "/view3";
export const linkPageView4 = "/view4";
export const linkPageView6 = "/view6";
export const linkPageBaseAPIChanger = "/change-api-url";
export const linkPageCart = "/cart";
export const linkPageMode = "/mode";

//Home Routes
export const linkHomeBase = "home";

//Dashboard Routes
export const linkDashboardBase = "/dashboard";

//Chat Routes
export const linkChatBase = "/session";

//Data Source Routes
export const linkDataSourceBase = "connection";
export const linkDataSourceList = linkDataSourceBase + "s";
export const linkDataSourceAddNew = `/${linkDataSourceBase}` + "/add-new"; // Need to change after adding withRouter to this page
export const linkDataSourceCreate = `/${linkDataSourceBase}` + "/create"; // Need to change after adding withRouter to this page
export const linkDataSourceSelectView = `/${linkDataSourceBase}` + "/view"; // Need to change after adding withRouter to this page
export const linkDataSourceSelect = `/${linkDataSourceBase}` + "/select"; // Need to change after adding withRouter to this page

//Project Routes
export const linkProjectBase = "project";
export const linkProjectList = linkProjectBase + "s";
export const linkProjectCreate = linkProjectBase + "/create";
export const linkProjectEdit = linkProjectBase + "/edit";
export const linkProjectCreateMaintain = linkProjectBase + "/view/:uid";
export const linkProjectDashboard = linkProjectBase + "/:uid/dashboard";
export const linkProjectChat = "/session";
export const linkProjectDatasource = "/data";
export const linkProjectPrompt = "/prompt";
export const linkProjectTemplate = "/template";
export const linkProjectReports = linkProjectBase + "/:uid/report";

//Prompt Routes
export const linkPromptBase = "/prompt";

//Prompt Routes
export const linkTemplateBase = "/template";

//Teams Routes
export const linkTeamsBase = "/teams";
export const linkTeamList = linkProjectBase + "/:uid" + linkTeamsBase;
export const linkTeam = linkProjectBase + "/:uid" + linkTeamsBase + "/:uid" + "/:name";
export const linkCreateTeam = linkTeamList + "/create";

//Users routes
export const linkUsersBase = "/users";
export const linkUsersList = linkUsersBase + "list";
export const linkUser = linkUsersList + "/:uid";

//Reports Routes
export const linkReportsBase = "/report";

//User settings
export const linkUserSettings = "user-settings";
//Usage
export const linkUsage = "/usage";

//Version Info
export const linkVersionInfo = "/version";

//Instructions Routes
export const linkInstructionsBase = "instruction";
export const linkInstructionsList = linkInstructionsBase + "s";
export const linkInstructionsAddNew = `${linkInstructionsBase}` + "/create";
export const linkInstructionsEdit = `${linkInstructionsBase}` + "/edit";

//Auth0
export const linkAuth0Login = "/v2/user/login";

//linknames
export const linkNamePageLogin = "Login";
export const linkNamePageView1 = "View1";
export const linkNamePageView2 = "View2";

//imports
//To be deleted
const View1 = React.lazy(() => import("./view/View1/View1"));
const View2 = React.lazy(() => import("./view/View2/View2"));
const View3 = React.lazy(() => import("./view/View3/View3"));
const View4 = React.lazy(() => import("./view/View4/View4"));
const View6 = React.lazy(() => import("./view/View6/View6"));
const PageMode = React.lazy(() => import("./view/PageMode/PageMode"));

//Auth Imports but not inside default layout
const PageDatadogAuthManager = React.lazy(
  () => import("./view/redirection/PageDatadogAuthManager")
);

//Home Imports
const Home = React.lazy(() => import("./view/home/PageHome"));

//Dashboard Imports
const Dashboard = React.lazy(() => import("./view/dashboard/PageDashboard"));

//Chat Imports
const Chat = React.lazy(() => import("./view/chat/PageChat/PageChat"));

//Data Source Imports
const DatasourceList = React.lazy(() => import("./view/datasource/PageDatasourceList"));
const DataSourceAddNew = React.lazy(() => import("./view/datasource/PageDatasourceAddNew"));
const CreateConnection = React.lazy(() => import("./view/datasource/PageCreateConnection"));
const DataSourceSelect = React.lazy(() => import("./view/datasource/PageDatasourceSelect"));

//Project Imports
const ProjectList = React.lazy(() => import("./view/project/PageProjectList"));
const ProjectCreate = React.lazy(
  () => import("./view/project/PageCreateProject/PageCreateProject")
);
const ProjectEdit = React.lazy(() => import("./view/project/PageEditProject/PageEditProject"));
const ProjectAddInstructions = React.lazy(
  () => import("./view/project/PageAddInstructions/PageAddInstructions")
);

//Prompt Imports
const Prompt = React.lazy(() => import("./view/chat/PageChat"));

//Prompt Imports
const ProjectData = React.lazy(() => import("./view/project/PageProjectData"));

//Teams Imports
const Teams = React.lazy(() => import("./view/team/PageTeams/PageTeams"));
const Team = React.lazy(() => import("./view/team/PageTeam"));
const CreateTeam = React.lazy(() => import("./view/team/PageCreateTeam/PageCreateTeam"));

//Users Imports
const Users = React.lazy(() => import("./view/team/PageUsers/PageUsers"));

//Reports Imports
const Report = React.lazy(() => import("./view/report/PageReport"));

//User Settings imports
const UserSettings = React.lazy(() => import("./view/PageUserSettings/PageUserSettings"));

//Instructions Imports
const InstructionsList = React.lazy(
  () => import("./view/instructions/PageInstructionsList/PageInstructionsList")
);

const CreateInstruction = React.lazy(
  () => import("./view/instructions/PageCreateInstruction/PageCreateInstruction")
);

const EditInstruction = React.lazy(
  () => import("./view/instructions/PageEditInstruction/PageEditInstruction")
);

export const devTestRoutes: IRouteObj[] = [
  {
    path: linkPageView1,
    exact: true,
    name: linkNamePageView1,
    component: View1,
  },
  { path: linkPageView2, name: linkNamePageView2, component: View2 },
  { path: linkPageView3, component: View3 },
  { path: linkPageView4, component: View4 },
  { path: linkPageView6, component: View6 },
  { path: linkPageCart, component: View4 },
  { path: linkPageMode, component: PageMode },
];

//Auth routes but not inside default layout
export const authRoutes: IRouteObj[] = [
  {
    path: linkPageDatadogAuthManagement,
    component: PageDatadogAuthManager,
  },
];

//routes
const routes: IRouteObj[] = [
  //Home Routes
  { path: linkHomeBase, component: Home },
  //Dashboard Routes
  { path: linkProjectDashboard, component: Dashboard },
  //Chat Routes
  { path: linkChatBase, component: Chat },
  //Data Source Routes
  { path: linkDataSourceList, component: DatasourceList },
  { path: linkDataSourceAddNew, component: DataSourceAddNew },
  // { path: linkDataSourceCreate + "/:datasourceKey", component: DataSourceCreate },
  { path: linkDataSourceCreate, component: CreateConnection },
  { path: linkDataSourceSelectView + "/:datasourceKey/:uid", component: DataSourceSelect },
  { path: linkDataSourceSelect + "/:datasourceKey", component: DataSourceSelect },
  //Project Routes
  { path: linkProjectList, component: ProjectList },
  { path: linkProjectCreate, component: ProjectCreate },
  { path: linkProjectEdit + `/:uid`, component: ProjectEdit },
  { path: linkProjectEdit + `/:uid` + "/new-instruction", component: ProjectAddInstructions },
  {
    path: linkProjectEdit + `/:uid` + "/edit-instruction/:instructionId",
    component: ProjectAddInstructions,
    props: { isEditPage: true },
  },
  {
    path: linkProjectBase + `/:uid` + linkProjectChat + "/:sessionUid?/:promptId?/:refresh?",
    component: Chat,
  },
  {
    path: linkProjectBase + `/:uid` + linkUsage + "/:sessionUid?/:promptId?/:refresh?",
    component: Chat,
    props: { isUsage: true },
  },
  { path: linkProjectBase + `/:uid` + linkProjectDatasource, component: ProjectData },
  //Prompt Routes
  {
    path: linkProjectBase + `/:uid` + linkProjectPrompt,
    component: Prompt,
    props: { isPrompt: true },
  },
  //Template Routes
  {
    path: linkProjectBase + `/:uid` + linkProjectTemplate,
    component: Prompt,
    props: { isPrompt: true },
  },
  //Teams Routes
  { path: linkTeamList, component: Teams },
  { path: linkTeam, component: Team },
  { path: linkCreateTeam, component: CreateTeam },
  { path: linkUsersList, component: Users },
  //Reports Routes
  { path: linkProjectReports, component: Report },
  //User settings
  { path: linkUserSettings, component: UserSettings },
  //Instructions Routes
  // { path: linkInstructionsList, component: InstructionsList },
  // { path: linkInstructionsAddNew, component: CreateInstruction },
  // { path: linkInstructionsEdit + `/:uuid`, component: EditInstruction },
];

export default routes;
